module.exports = __webpack_public_path__ + "img/image151.2003557f.jpg";